import React, { useMemo } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNavigation } from '../../../common/navigation';
import { TabsHistory } from '../../../app/components/TabsHistory';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';

import { PurchaseInvoiceSearch } from './PurchaseInvoiceSearch';

export const PurchaseInvoicesTvView: React.FC = () => {
  const pok = usePokCore();
  const nav = useNavigation();
  const { t, tk } = useTranslation('fvzLng');

  const handleClick = (id: string, newWindow?: boolean) => {
    nav.tvPurchaseInvoiceEditor(id, newWindow);
  };

  const getSummary = useMemo(
    () => (filterText?: string, filterColumns?: string) =>
      pok.purchaseInvoices.getSumAllUnsettledTvForPurchaseInvoices(
        t,
        tk,
        filterText,
        filterColumns,
      ),
    [pok.purchaseInvoices, t, tk],
  );

  const getDataUnsettled = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.purchaseInvoices.getAllUnsettledTvByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok, t, tk],
  );

  const getDataForMediaplaner = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.purchaseInvoices.getAllTvForMediaplanerByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok, t, tk],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">{t(tk.finance.tvInvoices)}</Card.Title>
        <TabsHistory
          activeKey="unsettled_all_invoices"
          id="unsettledInvoices"
          className="mb-3"
          mountOnEnter
          unmountOnExit
        >
          <Tab
            eventKey="unsettled_all_invoices"
            title={t(tk.finance.unsettled)}
            className="m-3"
          >
            <PurchaseInvoiceSearch
              getData={getDataUnsettled}
              getCount={pok.purchaseInvoices.getAllUnsettledTvCount}
              getSummary={getSummary}
              onRowClick={handleClick}
              mode="estimateItem"
              displayTeamsProjects={true}
              displayCreator={true}
              withFilterInColumns={true}
              withCountDays={true}
            />
          </Tab>
          <Tab
            eventKey="all_invoices"
            title={t(tk.finance.all)}
            className="m-3"
          >
            <PurchaseInvoiceSearch
              getData={getDataForMediaplaner}
              getCount={pok.purchaseInvoices.getAllTvForMediaplanerCount}
              displayTeamsProjects={true}
              mode="estimateItem"
              withFilterInColumns={true}
              withCountDays={true}
              displayStatus={true}
              onRowClick={handleClick}
            />
          </Tab>
        </TabsHistory>
      </Card.Body>
    </Card>
  );
};
